import React from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import {
  RenderInput,
  RenderSelect,
} from "../../Common/InputComponents/Inputs.jsx";
import {
  required,
  validateMutationIdentifier,
} from "../../../util/validations.js";
import {
  tooltipFluorophores,
  tooltipIdentifier,
  tubeFormatSelector,
} from "../../Common/Misc/Tooltips.jsx";

const fluorophoreOptions = [
  { name: "FAM/HEX", value: "FAM/HEX" },
  { name: "Cy5/Cy5.5", value: "Cy5/Cy5_5" },
];
const tubeFormatOptions = [
  { text: "Single Tube", value: "SingleTube" },
  { text: "Two Tube", value: "TwoTube" },
];

export const MutationDetectionIdentifier = ({ input, custom, index }) => {
  const validationErrorDetails =
    (custom &&
      custom.validatedAssayDetails &&
      custom.validatedAssayDetails[index]) ||
    {};
  const mutationDetectionIdentifier = input && input.name;

  const changeTargetUUID = (targetUUID) => {
    custom.change(`${mutationDetectionIdentifier}.uuid`, targetUUID);
    let inputIndex = mutationDetectionIdentifier.split("]")[0].split("[")[1];
    custom.actions.clearValidationMessages(inputIndex);
  };
  const resetUUID = () => {
    custom.change(`${mutationDetectionIdentifier}.uuid`, "");
  };

  return (
    <div className="inputs">
      <div className="row">
        <div className="col">
          <div className="form-group">
            <Field
              name={`${mutationDetectionIdentifier}.identifier`}
              placeholder="e.g., KRAS p.G12D or COSM521 (Human only)"
              className="form-control"
              type="text"
              component={RenderInput}
              label="Identifier:"
              validate={[required, validateMutationIdentifier]}
              tooltip={tooltipIdentifier("MutationDetection")}
              serverValidation={validationErrorDetails}
              changeTargetUUID={changeTargetUUID}
              onChange={resetUUID}
            />
          </div>
        </div>
        <div className="col">
          <div className="form-group">
            <Field
              name={`${mutationDetectionIdentifier}.fluorophores`}
              className="form-control"
              component={RenderSelect}
              label="Fluorophores:"
              tooltip={tooltipFluorophores}
            >
              {fluorophoreOptions &&
                fluorophoreOptions.map((option) => {
                  return (
                    <option key={option.name} value={option.value}>
                      {option.name}
                    </option>
                  );
                })}
            </Field>
          </div>
        </div>
        <div className="col">
          <div className="form-group">
            <Field
              name={`${mutationDetectionIdentifier}.assayFormat`}
              className="form-control"
              component={RenderSelect}
              label="Tube Format:"
              tooltip={tubeFormatSelector}
            >
              {tubeFormatOptions &&
                tubeFormatOptions.map((option) => {
                  return (
                    <option key={option.value} value={option.value}>
                      {option.text}
                    </option>
                  );
                })}
            </Field>
          </div>
        </div>
      </div>
    </div>
  );
};

MutationDetectionIdentifier.propTypes = {
  //fields: PropTypes.object.isRequired,
};
